import React from "react";
import classes from "./GalleryCard.module.css";

export const formatDate = (dateString) => {
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
    // hour: "2-digit",
    // minute: "2-digit",
    // hour12: true,
  };

  const date = new Date(dateString);
  const formattedDate = date.toLocaleString("en-US", options).toUpperCase();

  // Replace only the last comma with ' AT'
  const finalDate = formattedDate.replace(/,(?!.*,)/, " AT");
  return finalDate.replace(/AT/, ",");
};

const GalleryCard = ({ data }) => {
  return (
    <div className={classes.outer}>
      <img
        src={data?.images?.find((item) => item?.mainImage == "yes")?.url}
        alt={data?.images?.find((item) => item?.mainImage == "yes")?.imageTag}
      />
      <p>{formatDate(data?.createdAt)}</p>
    </div>
  );
};

export default GalleryCard;
